import React from "react"
import EmphasizedContent from "@blocks/EmphasizedContent";
import Grid from "@blocks/Grid";
import Flex from "@blocks/Flex";
import Button from "@blocks/Button";
import { useMemo } from "react";
import { useSalonManagerContext } from "@admin/components/templates/SalonManager/context";
import { ReactComponent as EnvelopeIcon } from '@icons/envelope.svg'

export default function TrackingDashboard({ trackings = [] }: Props) {
    const { salon } = useSalonManagerContext()
    const dashboard = salon.api.dashboard.tracking.use()

    const tracked = useMemo(() => trackings.reduce(
        (prev, curr) => prev + curr.participations.length, 0
    ), [trackings])

    if (!dashboard.data)
        return null

    return (
        <EmphasizedContent>
            <Flex justifyContent="space-between" alignItems="center">
                <Grid gap="5px">
                    <small>Tracked</small>
                    <h4>{tracked} / {dashboard.data.awards} awards</h4>
                </Grid>
                <Button icon={<EnvelopeIcon />} width="auto" type="tertiary" onClick={salon.actions.tracking.notify}>
                    Notify
                </Button>
            </Flex>
        </EmphasizedContent>
    )
}

interface Props {
    trackings: Admin.Resources.Tracking[] | undefined
}